module.exports = __webpack_public_path__ + "img/cbn.ee694cf6.svg";